"use client";

import { c as _c } from "react/compiler-runtime";
import { Fragment } from "react";
import { Menu, MenuItems, Transition } from "@headlessui/react";
import clsx from "clsx";
import { CompactMenuTrigger } from "./subcomponents/CompactMenuTrigger";
import { CompactMenuItemsPanel } from "./subcomponents/CompactMenuItemsPanel";
import { useCompactMenuFocus } from "./hooks/useCompactMenuFocus";
import { DEFAULT_ANCHOR, DEFAULT_MENU_CLASSES } from "./constants";
import type { CompactMenuProps } from "./types";
export function CompactMenu(t0) {
  const $ = _c(25);
  const {
    trigger,
    items,
    onItemSelect,
    className,
    triggerClassName,
    unstyledTrigger,
    menuClassName,
    unstyledMenu,
    itemsWrapperClassName,
    itemClassName,
    activeItemClassName,
    inactiveItemClassName,
    focusItemClassName,
    anchor,
    menuWidthClassName,
    disabled,
    activeItemId,
    closeOnSelect,
    "aria-label": ariaLabel,
    unstyledItems
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = clsx("tw-relative", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== activeItemClassName || $[3] !== activeItemId || $[4] !== anchor || $[5] !== ariaLabel || $[6] !== closeOnSelect || $[7] !== disabled || $[8] !== focusItemClassName || $[9] !== inactiveItemClassName || $[10] !== itemClassName || $[11] !== items || $[12] !== itemsWrapperClassName || $[13] !== menuClassName || $[14] !== menuWidthClassName || $[15] !== onItemSelect || $[16] !== trigger || $[17] !== triggerClassName || $[18] !== unstyledItems || $[19] !== unstyledMenu || $[20] !== unstyledTrigger) {
    t2 = t3 => {
      const {
        open,
        close
      } = t3;
      return <CompactMenuContent trigger={trigger} items={items} onItemSelect={onItemSelect} triggerClassName={triggerClassName} unstyledTrigger={unstyledTrigger} menuClassName={menuClassName} unstyledMenu={unstyledMenu} itemsWrapperClassName={itemsWrapperClassName} itemClassName={itemClassName} activeItemClassName={activeItemClassName} inactiveItemClassName={inactiveItemClassName} focusItemClassName={focusItemClassName} anchor={anchor} menuWidthClassName={menuWidthClassName} disabled={disabled} activeItemId={activeItemId} closeOnSelect={closeOnSelect} ariaLabel={ariaLabel} unstyledItems={unstyledItems} isOpen={open} close={close} />;
    };
    $[2] = activeItemClassName;
    $[3] = activeItemId;
    $[4] = anchor;
    $[5] = ariaLabel;
    $[6] = closeOnSelect;
    $[7] = disabled;
    $[8] = focusItemClassName;
    $[9] = inactiveItemClassName;
    $[10] = itemClassName;
    $[11] = items;
    $[12] = itemsWrapperClassName;
    $[13] = menuClassName;
    $[14] = menuWidthClassName;
    $[15] = onItemSelect;
    $[16] = trigger;
    $[17] = triggerClassName;
    $[18] = unstyledItems;
    $[19] = unstyledMenu;
    $[20] = unstyledTrigger;
    $[21] = t2;
  } else {
    t2 = $[21];
  }
  let t3;
  if ($[22] !== t1 || $[23] !== t2) {
    t3 = <Menu as="div" className={t1}>{t2}</Menu>;
    $[22] = t1;
    $[23] = t2;
    $[24] = t3;
  } else {
    t3 = $[24];
  }
  return t3;
}
interface CompactMenuContentProps extends Omit<CompactMenuProps, "className" | "menuWidthClassName" | "anchor" | "aria-label"> {
  readonly anchor: CompactMenuProps["anchor"];
  readonly menuWidthClassName: CompactMenuProps["menuWidthClassName"];
  readonly ariaLabel: CompactMenuProps["aria-label"];
  readonly isOpen: boolean;
  readonly close: () => void;
}
function CompactMenuContent(t0) {
  const $ = _c(35);
  const {
    trigger,
    items,
    onItemSelect,
    triggerClassName,
    unstyledTrigger: t1,
    menuClassName,
    unstyledMenu: t2,
    itemsWrapperClassName,
    itemClassName,
    activeItemClassName,
    inactiveItemClassName,
    focusItemClassName,
    anchor: t3,
    menuWidthClassName: t4,
    disabled: t5,
    activeItemId,
    closeOnSelect: t6,
    ariaLabel,
    unstyledItems: t7,
    isOpen,
    close
  } = t0;
  const unstyledTrigger = t1 === undefined ? false : t1;
  const unstyledMenu = t2 === undefined ? false : t2;
  const anchor = t3 === undefined ? DEFAULT_ANCHOR : t3;
  const menuWidthClassName = t4 === undefined ? "tw-w-40" : t4;
  const disabled = t5 === undefined ? false : t5;
  const closeOnSelect = t6 === undefined ? true : t6;
  const unstyledItems = t7 === undefined ? false : t7;
  const {
    menuItemsRef,
    focusInitialMenuItem
  } = useCompactMenuFocus(isOpen);
  let t8;
  if ($[0] !== ariaLabel || $[1] !== close || $[2] !== disabled || $[3] !== isOpen || $[4] !== trigger || $[5] !== triggerClassName || $[6] !== unstyledTrigger) {
    t8 = <CompactMenuTrigger trigger={trigger} triggerClassName={triggerClassName} unstyledTrigger={unstyledTrigger} disabled={disabled} ariaLabel={ariaLabel} isOpen={isOpen} close={close} />;
    $[0] = ariaLabel;
    $[1] = close;
    $[2] = disabled;
    $[3] = isOpen;
    $[4] = trigger;
    $[5] = triggerClassName;
    $[6] = unstyledTrigger;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const t9 = unstyledMenu ? undefined : DEFAULT_MENU_CLASSES;
  let t10;
  if ($[8] !== menuClassName || $[9] !== menuWidthClassName || $[10] !== t9) {
    t10 = clsx(t9, menuWidthClassName, menuClassName);
    $[8] = menuClassName;
    $[9] = menuWidthClassName;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== activeItemClassName || $[13] !== activeItemId || $[14] !== close || $[15] !== closeOnSelect || $[16] !== focusItemClassName || $[17] !== inactiveItemClassName || $[18] !== itemClassName || $[19] !== items || $[20] !== itemsWrapperClassName || $[21] !== onItemSelect || $[22] !== unstyledItems) {
    t11 = <CompactMenuItemsPanel items={items} activeItemId={activeItemId} onItemSelect={onItemSelect} close={close} closeOnSelect={closeOnSelect} itemClassName={itemClassName} activeItemClassName={activeItemClassName} inactiveItemClassName={inactiveItemClassName} focusItemClassName={focusItemClassName} itemsWrapperClassName={itemsWrapperClassName} unstyledItems={unstyledItems} />;
    $[12] = activeItemClassName;
    $[13] = activeItemId;
    $[14] = close;
    $[15] = closeOnSelect;
    $[16] = focusItemClassName;
    $[17] = inactiveItemClassName;
    $[18] = itemClassName;
    $[19] = items;
    $[20] = itemsWrapperClassName;
    $[21] = onItemSelect;
    $[22] = unstyledItems;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== anchor || $[25] !== menuItemsRef || $[26] !== t10 || $[27] !== t11) {
    t12 = <MenuItems ref={menuItemsRef} anchor={anchor} className={t10}>{t11}</MenuItems>;
    $[24] = anchor;
    $[25] = menuItemsRef;
    $[26] = t10;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== focusInitialMenuItem || $[30] !== t12) {
    t13 = <Transition as={Fragment} enter="tw-transition tw-duration-150 tw-ease-out" enterFrom="tw-opacity-0 tw-translate-y-1" enterTo="tw-opacity-100 tw-translate-y-0" leave="tw-transition tw-duration-100 tw-ease-in" leaveFrom="tw-opacity-100 tw-translate-y-0" leaveTo="tw-opacity-0 tw-translate-y-1" afterEnter={focusInitialMenuItem}>{t12}</Transition>;
    $[29] = focusInitialMenuItem;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t13 || $[33] !== t8) {
    t14 = <>{t8}{t13}</>;
    $[32] = t13;
    $[33] = t8;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  return t14;
}
export type { CompactMenuItem } from "./types";